/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { ActivatedRoute } from '@angular/router';
import { InfiniteMatDataSource } from '@gh/common-external-shared';
import { ID } from '@gh/common-shared-data';
import {
  DialogService,
  FileInvalidEvent,
  InvalidFileReason,
  NotificationService,
  WaitingService,
  yesAnswer,
  yesCancelConfirmation,
} from '@gh/core-ui';
import { openInNewWindow } from '@gh/core-util';
import { filter$, switchMap$ } from '@gh/rx/operators';
import { InvoicesModel, SupplierInvoicesListBusinessService } from '../../resources';

@Component({
  selector: 'gh-invoices',
  templateUrl: 'supplier-invoices-list.component.html',
})
export class SupplierInvoicesListComponent implements OnInit {
  @ViewChild(MatSort, { static: false }) sort: MatSort;

  dataSource: InfiniteMatDataSource<InvoicesModel>;
  displayedColumns: string[] = ['fileName', 'updatedDate', 'id'];

  constructor(
    private businessService: SupplierInvoicesListBusinessService,
    private notifications: NotificationService,
    private dialogService: DialogService,
    private waitings: WaitingService,
    private route: ActivatedRoute,
  ) {
  }

  ngOnInit(): void {
    this.subscribeToNavigation();
  }

  getInvoiceId(index: number, invoice: InvoicesModel): ID {
    return invoice.id;
  }

  delete(invoice: InvoicesModel): void {
    this.dialogService
      .confirmation(yesCancelConfirmation('msg_inv_delete')).pipe(
      filter$(yesAnswer),
      switchMap$(() =>
        this.businessService.delete(invoice.id).pipe(this.waitings.operator())))
      .subscribe(
        () => {
          this.notifications.success('msg_invoice_deleted');
          this.dataSource.fire();
        },
        this.notifications.processAll,
      );
  }

  view(invoice: InvoicesModel): void {
    openInNewWindow(invoice.fileUrl);
  }

  onUploadError(event: FileInvalidEvent): void {
    this.notifications.error({
      [InvalidFileReason.TooLarge]: 'msg_item_picture_not_correct',
      [InvalidFileReason.NotAccepted]: 'msg_picture_invalid_extension',
    }[event.reason]);
  }

  onUploadSuccess(): void {
    this.loadInvoices();
  }

  private loadInvoices(): void {
    this.dataSource = InfiniteMatDataSource.wrap(this.businessService.getAll());
    this.dataSource.sort = this.sort;
  }

  private subscribeToNavigation(): void {
    this.route
      .params
      .subscribe(() => this.loadInvoices());
  }
}
